module.exports = __webpack_public_path__ + "img/274.2d378c7a.jpg";